import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import useApi from '../../hooks/useApi';
import EventToAdminBind from './EventToAdminBind';
//
// Компонент выводит два списка:
// 1) Список привязанных к мероприятию админов
// 2) Список админов, которых еще можно привязать
// Предполагается (но не проверяется) страницу смотрит root
//
const EventToAdminList = ({ event }) => {
	const { t } = useTranslation();
    const user = useSelector(state => state.auth.user);
    // eslint-disable-next-line
    const [ pBinds, setPBinds ] = useState({ event: event._id });
	const [ binds, errorBinds, isLoadingBinds ] = useApi({ type: 'get', method: '/a2e', params: pBinds });
    // eslint-disable-next-line
    const [ pAdmins, setPAdmins ] = useState({ role: 'admin' });
	const [ admins, errorAdmins, isLoadingAdmins ] = useApi({ type: 'get', method: '/users', params: pAdmins });
    const [ bindsTo, setBindsTo ] = useState(null);

    // Убираем из второго списка тех, кто уже есть в первом
    useEffect(() => {
        if(!binds || !admins) return;
        for(let i = 0; i < binds.a2e.length; i ++) {
            let admin_id = binds.a2e[i].admin._id;
            let index = admins.users.findIndex(user => user._id === admin_id);
            if(index >= 0) {
                admins.users.splice(index, 1);
            }
        }
        setBindsTo(admins.users);
    }, [binds, admins]);
/*
    TODO: Эта функция будет нужна, когда поймем как вызывать из <EventToAdminBind>
    обновление родителя (чтобы сразу отобразить новые списки). Пока не ясно как
    сделать вызов после того, как изменение привязки произошло на сервере. Часто
    вызов обновления проходит раньше, чем изменения произошли.
    const update = () => {
        // Для форсирования повторного запроса АПИ
        // мы делаем вид что поменяли параметры запроса.
        setParams({ admin: user._id });
    };
*/
    // Добавили в марте 2026 - убрать список админов для всех кроме рута
    if (user.role !== 'root') return null;

	return (
    <div>
        {/*<h2>{t('eventview.admins')}</h2>*/}
        <h2>{t('eventview.binds')}</h2>
        {errorBinds && <div className='error'>{t(errorBinds)}</div>}
        {isLoadingBinds && <div>{t('common.loading')}</div>}
        {binds &&
        <React.Fragment>
            {binds.a2e.length ?
            <ul>
            {binds.a2e.map(item => (
                <li key={item._id}>
                    <NavLink to={'/cabinet/userview/'+item.admin._id}>{item.admin.name}</NavLink>
                    <EventToAdminBind admin={item.admin._id} event={event._id} bind={false}/>
                </li>
            ))}
            </ul> : <p>{t('eventview.nobinds')}</p>}
        </React.Fragment>}


        {user.role === 'root' &&
        <React.Fragment>
        {/* Привязка администраторов доступна только руту */}
            <h2>{t('eventview.bindto')}</h2>
            {errorAdmins && <div className='error'>{t(errorAdmins)}</div>}
            {isLoadingAdmins && <div>{t('common.loading')}</div>}
            {bindsTo &&
            <React.Fragment>
                {bindsTo.length ?
                <ul>
                {bindsTo.map(item => (
                    <li key={item._id}>
                        <NavLink to={'/cabinet/userview/'+item._id}>{item.name}</NavLink>
                        <EventToAdminBind admin={item._id} event={event._id} bind={true}/>
                    </li>
                ))}
                </ul> : <p>{t('eventview.nobindto')}</p>}
            </React.Fragment>}
        </React.Fragment>}
    </div>
	);
};

EventToAdminList.propTypes = {
    event: PropTypes.object.isRequired,
};

export default EventToAdminList;
